export const Config = {
    Url : 'https://lbms-server.onrender.com'
}